import React from "react";
import Link from "next/link";

import { Brand } from "@/custom-types/Brand";

import Image from "@/components/Image";

type Props = {
  initialBrands: Array<Brand>;
};

const BrandCoins: React.FC<Props> = ({ initialBrands }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-xl">
    {initialBrands.map((brand, i) => (
      <Link
        href={`/brands/${brand.slug}`}
        key={brand.id}
        className="block w-full"
      >
        <Image
          src={brand.logo}
          alt={`${brand.name} logo`}
          sizes={[244, 355, 166, 180, null, 244]}
          ratio="square"
          imgixParams={{ bg: "fff" }}
          className="rounded-full shadow-low"
          disableLazyLoad={i < 6}
        />
        <div className="pt-md text-center text-green underline">
          {brand.name}
        </div>
      </Link>
    ))}
  </div>
);

export default BrandCoins;
